import type { ReactNode } from 'react';
import styles from './Badge.module.css';

export type BadgeTone = 'neutral' | 'positive' | 'negative' | 'attention';

export interface BadgeProps {
  /** Visible text; colour is never the only signal. */
  children: ReactNode;
  tone?: BadgeTone;
  /** Non-colour marker (shape/pip) rendered aria-hidden beside the text. */
  shape?: string;
  /** Machine value for tests and variant styling. */
  'data-badge'?: string;
}

// Text badge with a non-colour shape marker (DESIGN_SYSTEM.md §12: status
// never depends on colour alone). The shape is aria-hidden; the text is the
// accessible name.
export function Badge({ children, tone = 'neutral', shape, ...rest }: BadgeProps) {
  return (
    <span className={styles.badge} data-tone={tone} {...rest}>
      {shape && (
        <span className={styles.badgeShape} aria-hidden="true">
          {shape}
        </span>
      )}
      <span className={styles.badgeText}>{children}</span>
    </span>
  );
}
